import { client } from "/lib/sanity/client";
import { BikeCard } from "./bikeCard";

export default async function HardcodedBikeGrid() {
  const bikeImages = await client.fetch<
    { slug: { current: string }; image: any }[]
  >(
    `*[_type == "bikeModels" && slug.current in ["remidemi-xl", "remidemi"]]{
      slug,
      image{..., asset->{_id, metadata{dimensions, lqip}}}
    }`
  );

  const longImage =
    bikeImages?.find((b) => b.slug.current === "remidemi-xl")?.image ?? null;
  const shortImage =
    bikeImages?.find((b) => b.slug.current === "remidemi")?.image ?? null;

  return (
    <div className="flex flex-col md:flex-row items-center justify-center gap-6 ">
      <BikeCard
        title="Lang modell"
        subtitle="Benno, Tern, Hercules"
        passengers={2}
        price={2200}
        image={longImage}
        href="/sykler?fokus=lang"
        action={{ type: "link", href: "/sykler?fokus=lang", label: "Bestill" }}
      />
      <BikeCard
        title="Kort modell"
        subtitle="Benno, Tern"
        passengers={1}
        price={2000}
        image={shortImage}
        href="/sykler?fokus=kort"
        action={{ type: "link", href: "/sykler?fokus=kort", label: "Bestill" }}
      />
    </div>
  );
}
